export default __webpack_public_path__ + "static/media/B.a7a9924a.svg";